<template>
    <div v-if="content">
        <div>
            <string-content :content="content" field="title" tag="h1" />
            <string-content :content="content" />
        </div>
        <printer>
            <div class="content">
                <string-content :content="content" field="title" tag="h1" />
                <string-content :content="content" />
            </div>
        </printer>
    </div>
</template>
<script>
import Vue from 'vue';

import StringContent from '../../../../../../_common/components/content/string-content.js';
import Printer from '../../../common/printer/printer.vue';

export default {
    name: 'rules-inner',
    components: { StringContent, Printer },
    data: () => ({
        contentStrings: [],
    }),
    computed: {
        rule: function() {
            return this.$route.params.rule;
        },
        lang: function() {
            return Vue.state.lang.currentLang;
        },
        content: function() {
            let result;
            for (const item of this.contentStrings) {
                if (item.alias === this.rule) {
                    if (item.language === this.lang) {
                        result = item;
                        break;
                    }
                    else if (item.language === "en") {
                        result = item;
                    }
                }
            }
            return result || this.contentStrings.find(item => item.name === this.rule);
        }
    },
    async created() {
        await Vue.state.content.strings.ensure();
        this.contentStrings = Vue.state.content.strings.get();
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/rules/rules-inner.vue